const en = {
  translation: {
    home: "Home",
    login: "Login",
    register: "Register",
    language: "Language",
    confirm: "Confirm",
    pleaseEnterUsername: "Please enter the account number",
    pleaseEnterPassword: "Please enter the password",
    pleaseConfirmPassword: "Please confirm password",
    registerSuccessText: "Register success! Let's login",
    wrongCredential: "Username or password incorrect",
    loginSuccessText: "Login success",
    recharge: "Recharge",
    trend: "Trend",
    profile: "Profile",
    promotion: "Preferential Activities",
    productDetail: "Product Introduction",
    onlineService: "Online Service",
    productDetailContent:
      "เรียนลูกค้า วิธีการเติมเงินจะได้รับการอัปเดตตามเวลาจริง โปรดปรึกษาฝ่ายบริการลูกค้าก่อนการเติมเงินแต่ละครั้งเพื่อรับบัญชีธนาคารล่าสุด หากโอนเงินผิดบัญชีหรือเติมเงินที่ไม่สอดคล้องกับวิธีการบริการลูกค้าจะส่งผลให้ ถือเป็นโมฆะการสูญเสียจะตกเป็นภาระของบริษัทของเรา ขาดความรับผิดชอบ! ! เวลาให้บริการ 09:30-22:30 น. ทุกวัน ขอบคุณที่สนับสนุน ETF ขอให้ชีวิตมีความสุข!",
    productDetailContent1:
      "1. วิธีทำกิจกรรม(แพลตฟอร์ม) จะมีสามตัวที่นับรวมกัน (เช่น 3+5+2=10 เรียกว่า เล็ก) ถ้ามากกว่า 10 เรียกว่า ใหญ่ ( 1-10 เล็ก) ( 11-18 ใหญ่) 1,3,5,7,9,11, 13,15,17 (คี่); 2,4,6,8,10,12,14,16,18 (คู่)",
    productDetailContent2:
      "2. ผลการทำกิจกรรม (หลักพัน) ขึ้นอยู่กับจำนวนเงินที่ลูกค้าใช้ไป",
    productDetailContent3:
      "3. อัตราค่าเดินทางขึ้นอยู่กับระดับห้อง (เริ่มต้น, กลาง, VIP)",
    rechargeOffline: "Recharge offline",
    bankToPay: "Online Banking Payment",
    rechargeOnlineBank: "Contact Service",
    cancel: "Cancel",
    pleaseEnterRechargeAmount: "Please select recharge amount",
    fundDetail: "Fund details",
    investmentRecord: "Investment Record",
    securityCenter: "Security Center",
    customerService: "Contact customer service",
    setting: "Settings",
    balance: "Account Balance",
    todayProfit: "Profit today",
    loginPassword: "Login Password",
    withdrawPassword: "Withdraw Password",
    connectBankAccount: "Add withdraw information",
    updateLoginPassword: "Update login password",
    oldPassword: "Old password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    pleaseenterOldPassword: "Please enter old password",
    pleaseenterNewPassword: "Please enter new password",
    oldPasswordIncorrect: "Old Password Incorrect",
    passwordNotMatch: "Password not match",
    updateWithdrawPassword: "Update withdraw password",
    withdrawAmount: "Withdraw amount",
    somethingWentWrong: "Something went wrong !",
    userNotSetWithdrawPassword: "Please set withdraw password",
    pleaseEnterWithdrawAmount: "Please enter withdraw amount",
    remainingBalance: "Account Currency",
    until: "Until: ",
    rounds: "Number of rounds ",
    tradeCategory: "Trade Category",
    singleRound: "Single Round",
    operation: "Operation",
    user: "User",
    name: "Name",
    lastname: "Lastname",
    cryptoAddress: "Crypto Address",
    network: "Network",
    accountType: "Account Type",
    crypto: "crypto",
    bank: "Bank",
    registerNow: "Register Now",
    alreadyHaveAccount: "Already Have Account?",
    shortTermRoom: "short-term treasure-junior room",
    longTermRoom: "long-term treasure-junior room",
    myProfile: "My Profile",
    withdraw: "Withdraw",
    logout: "Log out",
    settingLanguage: "Setting Language",
    investAmount: "Single investment amount",
    profitAmount: "profit amount",
    transactionType: "Transaction Type",
    time: "Time",
    investSuccess: "Successful investment",
    investFail: "Investment failed",
    status: "Status",
    history: "History",
    eventDetail: "Event Details",
    personalLoan: "Unsecured personal loans",
    hotProduct: "Hot Product",
    marketTrend: "Market Trends",
    deposit: "Deposit",
    usernameMustBeEnglish: "Username must be English",
    personalData: "Personal data",
    general: "General",
    verification: "Verification",
    verifyNow: "Verify now",
    balanceHistory: "Balance history",
    other: "Other",
    email: "Email",
    phoneNumber: "Phone Number",
    emailOrPhone: "Email or Phone",
    userId: "User ID",
    emailRequired: "Email is required",
    phoneNumberRequired: "Phone number is required",
    emailOrPhoneRequired: "Email or phone number is required",
    invalidEmailOrPhone: "Enter a valid email address or phone number",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    passwordRequired: "Password is required",
    tradeNotice: "Open trades without confirmation (only for Real account)",
    binary: "Binary",
    sellTradeConfirm: "Sell trades without confirmation",
    notifications: "Notifications",
    closeTrade: "Close trade results alerts",
    supportTeamAlert: "Support team message alert",
    welcome: "Welcome to",
    signUpWithEmailOrPhone: "Sign up with email or phone",
    accountVerification: "Account Verification",
    emailConfirmation: "Email Confirmation",
    confirmSuccessfully: "Confirm successfully",
    continue: "Continue",
    backToProfile: "Back to Profile",
    checkInbox: "Check your inbox",
    emailSent: "We sent a confirmation code to your email",
    enterCode: "Enter code from the email",
    ifDontReceive: "If you have not received the code, you can",
    requestNewCode: "request another code",
    skipThisStep: "Skip this step",
    personalDetail: "Personal Details",
    personalDetailDes:
      "Providing correct personal information will facilitate the verification of your account and its funding. The details you provide will be kept confidential.",
    personalInfo: "Personal info",
    personalInfoDes1: "Provide your personal data exactly",
    personalInfoDes2: "as it appears on your ID to avoid ",
    personalInfoDes3: "verification issues in the future.",
    nameInfo:
      "Enter your first and last name exactly as they appear on your identification document.",
    male: "Male",
    female: "Female",
    dateOfBirth: "Date of birth",
    country: "Country of citizenship",
    address: "Address of residence",
    addressNote: "Please make sure the address is correct",
    city: "City",
    residentialAddress: "Residential Address",
    postalCode: "Postal code",
    submit: "Submit",
    proofOfIdentity: "Proof of identity",
    proofOfIdentityInfo:
      "AML laws and regulations require us to verify your identity. This keeps our platform secure and enables us to process payments faster. The documents you are about to send must be clearly visible. For more information",
    docToShow: "The socument must clearly show:",
    yourPhoto: "Your photo",
    yourFullname: "Your fullname",
    expiryDate: "Expiry date",
    documentnumber: "Document number",
    yourSignature: "Your signature",
    uploadDocuments: "Upload documents",
    chooseFileFront: "Choose front file",
    chooseFileBack: "Choose back file",
    upload: "Upload a JPG, PNG or PDF file, max size 15 MB",
    or: "or",
    maxSize: "max size",
    here: "here",
    manual: "manual",
    howToAttach: "How to propery attach documents",
    chooseCountry: "Choose the country of issue",
    selectDocumentType: "Select document type",
    useValid: "Use a valid government-issued photo ID.",
    passport: "Passport",
    drivingLicence: "Driver's license",
    idCard: "ID card",
    residencePermit: "Residence permit",
    uploadInfo: "Upload front page with photo",
    uploadDescription:
      "Upload a color image of the entire document. Screenshots are not allowed. JPG or PNG format only.",
    chooseFile: "Choose file",
    processing: "processing",
    uploading: "Please wait while uploading",
    createAccount: "Create account",
    password: "Password",
    minCharactor: "More than 6 charactors",
    forgetPassword: "Forget password?",
    myTrades: "My trades",
    active: "Active",
    closed: "Closed",
    startTrading: "Start trading to see your activity here.",
    oneMinPlus: "1+ Min",
    fiveMinPlus: "5+ Min",
    asset: "Assets",
    yourProfile: "Your profile photo",
    notAllow: "It is not allowed to publish",
    sexually: "sexually explicit or pornographic images",
    incite: "images intended to incite ethnic or racial hatred or hostility",
    underAge: "photos of people under the age of 18",
    copyRight: "third-party copyright protected photos",
    imageLarger:
      "images larger than 5 MB and in a format other than JPG or PNG",
    faceMustBeClearly: "Your face must be clearly visible in the photo.",
    allPhotos:
      "All photos and videos you upload must meet these requirements or they may be removed.",
    selectAPhoto: "Select a photo",
    saveChange: "Save Changes",
    changePhoto: "Change photo",
    registerDate: "Date registered",
    idProfile: "Profile ID",
    gender: "gender",
    contactInformation: "Contact information",
    chooseAsset: "Choose an asset",
    timer: "Timer",
    expectReturn: "Expect return",
    up: "Up",
    down: "Down",
    investment: "Investment",
    statusType: "Status type",
    openingTime: "Opening time",
    cloingTime: "Closing time",
    expiringTime: "Expiring time",
    return: "Return",
    positionId: "Position ID",
    closingMethod: "Closing method",
    expired: "Expired",
    invalidOtpCode: "Invalid OTP code",
    province: "Province",
    fillDataSuccessfully: "You fill personal data successfully!",
    verifySuccessfully: "You verify identity successfully!",
    verifyPending: "Your verify identity is pending",
    graphType: "Graph type",
    closingPrice: "closingPrice",
    openingPrice: "Opening price",
    closingTime: "Closing time",

    accountNo: "accountNo",
    accountName: "account name",
    recieverName: "Reciever name",
    rechartRecord: "Rechart record",
    withdrawRecord: "Withdraw record",
    profitRecord: "Profit record",
    memberLevel: "Member level",
    totalAssets: "Total assets",
    onlineNumber: "Online number",
    memberID: "member ID",
    goldMember: "Gold Member",
    vipMember: "VIP Member",
    receiptType: "Receipt Type",
    bankName: "Bank name",
    viewCardRecord: "View card record",
    supportText: "Contact online customer service",

    bankCardNumber: "Bank card number",
    payee: "payee",
    USDTAddress: "USDT address",
    topupNotice:
      "Please contact online customer service for proceed your transaction",
    topupBankNotice:
      "Please contact online customer service for the latest account charges!",
    warmRemindertitle: "Warm reminder",
    warmRemindertext: "รับทราบการชำระเงินด้วยรหัส QR แล้วกรอกจำนวนเงินที่จะส่ง",
    remark: "Remark",
    pleaseEnterTheRechargeAmount: "Please enter the recharge amount",
    pleaseEnterTheWithdrawAmount: "Please enter the withdraw amount",
    pleaseEnterANote: "Please enter a note",
    rechargeAmount: "Recharge amount",
    bankCardNotice:
      "When you have connect your account, please contact customer service if you want to cancel",
    account: "Account",
    financialBill: "Financial Bill",
    totalInvestment: "Total investment",
    totalIncome: "Total Income",
    totalProfitAndLoss: "Total profit and loss",
    bankCard: "Bank card",
    nickname: "Nickname",
    inputRechargeAmount: "Input recharge amount",
    haveAccount: "Have account?",
    rechargeRecord: "Recharge record",
    lobby: "Lobby",
    distance: "distance",
    periodLottery: "profit lottery",
    minutes: "minutes",
    seconds: "seconds",
    lotteryDraw: "lottery draw",
    period: "period",
    issueNumber: "issue number",
    lotteryResult: "lottery result",
    topupSuccessTitle: "Recharge success",
    withdrawSuccessTitle: "Withdraw success",
    back: "Back",
    pending: "Pending",
    success: "Success",
    enterAmount: "Enter amount",
    deleteConfirm: "Are you sure to delete?",
    depositList: "Deposit List",
    depositDate: "Deposit Date",
    profit: "Profit",

    amount: "Amount",
    tNo: "No",
    date: "Date",
    customerName: "Customer Name",
    pleaseConnectYourAccount: "Please Connect Your Account",
    connectAccountSuccess: "Connect account success",
    buyPoints: "Buy points",
    buy: "Buy",
    insufficientBalance: "Insufficient balance",
    pleaseEnterBuyAmount: "Please enter buy amount",
    update: "Update",
    pleaseSelectOptions: "Please select options",
    enterMessage: "Enter message",
    bankPayment: "Bank card payment",

    usernameExist: "Account number is already exist",
    unSuccess: "Unsuccess",
    transactionTimes: "Number of transactions",
    people: "people",
    minimumPurchase: "Single minimum purchase",
    enterMinimum: "Enter the minimum amount",
    passwordIncorrect: "Password is incorrect",
    minimumBalance: "Minimum balance",
    pleaseEnterAccountName: "Please enter a account name",
    pleaseEnterBankName: "Please enter a bank name",
    tradeMinimumBalance: "Insufficient minimum balance",
    phone: "Phone",
  },
};

export default en;
